import { createContext } from 'react';

export type AddPicturesFromIncidentFormModalContextProps = {
  closeModal: () => void
  openModal: (pictures: File[]) => void
  pictures: File[]
  isOpen: boolean
}

export const AddPicturesFromIncidentFormModalContext = createContext<AddPicturesFromIncidentFormModalContextProps | null>(null)